import { lazy } from 'react'
import {
	Route, RouterProvider,
	createBrowserRouter,
	createRoutesFromElements
} from 'react-router-dom'
import * as constants from 'resources/constants'
import { Role } from 'resources/types'
import LoginPage from 'views/login'
import LayoutWithSidebar from './LayoutWithSidebar'
import ProtectedRoute from './ProtectedRoute'
import RouteWrapper from './RouteWrapper'

const RealtorsPage = lazy(() => import('views/realtors'))
const RealtorPage = lazy(() => import('views/realtor'))
const CreateAccountPage = lazy(() => import('views/createAccount'))
const CreateCompanyPage = lazy(() => import('views/createCompany'))
const AccountActivation = lazy(() => import('views/accountActivation'))
const ManageUsers = lazy(() => import('views/users/manageUsers'))
const ClientRegistrationPage = lazy(() => import('views/clientRegistration'))
const RegionPage = lazy(() => import('views/regions'))
const CommunitiesPage = lazy(() => import('views/communities'))
const ProfilePage = lazy(() => import('views/profile'))
const ResetPasswordPage = lazy(() => import('views/resetPassword'))
const RewardsPage = lazy(() => import('views/rewards'))
const BonusLevelsPage = lazy(() => import('views/bonusLevels'))
const UnclaimedPointsPage = lazy(() => import('views/unclaimedPoints'))
const AssignedToMePage = lazy(() => import('views/assignedTo'))
const NotificationsPage = lazy(() => import('views/notifications'))
const CampaignsPage = lazy(() => import('views/Campaigns'))
const AutoNotificationPage = lazy(() => import('views/autoNotification'))
const EventsPage = lazy(() => import('views/events'))
const AdminClientRegistrationPage = lazy(() => import('views/adminClientRegistration'))
const AdminSettingsPage = lazy(() => import('views/adminSettings'))
const InformationPage = lazy(() => import ('views/information'))
const MyPointsPage = lazy(() => import('views/myPoints'))
const PointsReportPage = lazy(() => import('views/pointsReport'))
const CompleteProfilePage = lazy(() => import('views/completeProfile'))
const NotFound404Page = lazy(() => import('views/404NotFound'))
const NotAuthorized403Page = lazy(() => import('views/403NotAuthorized'))


const TestPage = lazy(() => import('views/testPage'))

const router = createBrowserRouter(createRoutesFromElements([
	<Route path='/' element={<RouteWrapper />}>
		<Route index element={<LoginPage />} />
		<Route path={constants.loginPage} element={<LoginPage />} />
		<Route path={constants.createAccountPage} element={<CreateAccountPage />} />
		<Route path={constants.createCompanyPage} element={<CreateCompanyPage />} />
		<Route path={constants.accountActivation} element={<AccountActivation />} />
		<Route path={constants.resetPasswordURL} element={<ResetPasswordPage />} />

		<Route element={<ProtectedRoute />}>
			<Route path={constants.completeProdileURL} element={<CompleteProfilePage />} />

			<Route element={<LayoutWithSidebar />}>
				<Route path={constants.realtorPage} element={<RealtorPage />} />
				<Route path={constants.clientRegistrationPageURL} element={<ClientRegistrationPage />} />
				<Route path={constants.testPage} element={<TestPage />} />
				<Route path={constants.profilePage} element={<ProfilePage />} />
				<Route path={constants.notificationsURL} element={<NotificationsPage />} />
				<Route path={constants.notificationURL} element={<NotificationsPage />} />
				<Route path={constants.eventsURL} element={<EventsPage />} />
				<Route path={constants.informationURL} element={<InformationPage />} />

				{/* Realtor Routes */}
				<Route element={<ProtectedRoute userRole={[Role.REALTOR]} />}>
					<Route path={constants.myPointsURL} element={<MyPointsPage />} />
				</Route>

				{/* Company Roles */}
				<Route element={<ProtectedRoute userRole={[Role.ADMIN, Role.ACCOUNT_OWNER, Role.MANAGER, Role.SALES]} />}>
					<Route path={constants.realtorsPage} element={<RealtorsPage />} />
					<Route path={constants.assignedToMeURL} element={<AssignedToMePage />} />
				</Route>

				{/* Admin Routes */}
				<Route element={<ProtectedRoute userRole={[Role.ADMIN, Role.ACCOUNT_OWNER, Role.MANAGER, Role.SALES]} />}>
					<Route path={constants.regionsURL} element={<RegionPage />} />
					<Route path={constants.communitiesURL} element={<CommunitiesPage />} />
					<Route path={constants.manageUsersPage} element={<ManageUsers />} />
					<Route path={constants.rewardsURL} element={<RewardsPage />} />
					<Route path={constants.bonusLevelURL} element={<BonusLevelsPage />} />
					<Route path={constants.unclaimedPointsURL} element={<UnclaimedPointsPage />} />
					<Route path={constants.notificationCampaignsURL} element={<CampaignsPage />} />
					<Route path={constants.autoNotificationsURL} element={<AutoNotificationPage />} />
					<Route path={constants.adminClientRegistrationPageURL} element={<AdminClientRegistrationPage />} />
					<Route path={constants.adminSettingsURL} element={<AdminSettingsPage />} />
					<Route path={constants.pointsReportsURL} element={<PointsReportPage />} />
				</Route>
			</Route>
		</Route>

		<Route path={constants.notAuthorized} element={<NotAuthorized403Page />} />
		 {/* 🧭 Catch-all 404 route */}
		<Route path='*' element={<NotFound404Page />} />
	</Route>,
]))

const Routes = () => <RouterProvider router={router} />
export default Routes
